export const pre = ''
export const arrowBodyProps = {
  strokeLinecap: "round",
  strokeDasharray: "0.5 8",
  strokeWidth: "4",
};